import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import usePageTitle from 'hooks/usePageTitle';

import { CloseIcon, IdentifyIcon, ShareIcon } from 'ui-component/custom-icons/icons';

import Breadcrumbs from './components/Breadcrumbs';
import Summary from './components/Summary';
import Logs from './components/Logs';
import QualityControlList from './components/QualityControlList';
import MoveToPicklistModal from './modals/MoveToPicklistModal';
import useIsMobile from 'utils/isMobileUtils';
import BreadcrumbsMobile from './components/BreadcrumbsMobile';
import QualityControlListMobile from './components/QualityControlListMobile';
import { FaTimes } from 'react-icons/fa';


// ✅ Clear
function OperationQualityControlView({ edit }) {
    const { id } = useParams();
    const [setPageTitle] = usePageTitle('Operations');
    const [toggleCheckboxActionStatus, setToggleCheckboxActionStatus] = useState(false);
    const [openGradingModal, setOpenGradingModal] = useState(false)
    const [showMoveToPicklistModal, setShowMoveToPicklistModal] = useState(false);
    const [countSelectedItems, setCountSelectedItems] = useState(0);

    useEffect(() => {
        return () => {
            setPageTitle(null);
        };
    }, []);
    const history = useNavigate();
    
    
    const [operationDetails, setOperationDetails] = useState({
        id: '',
        referenceNo: '',
        purchaseInvoiceId: '',
        status: '',
        action: '',
        type: '',
        isCompleted: '',
        products: [],
		logs: [],
		status: '',
		invoice: {},
		sales_order: {},
        purchaseOrderNumber: '',
        supplier: {}
    });

    const toggleCheckboxAction = (bool) => {
        setToggleCheckboxActionStatus(bool)
    }

    useEffect(() => {
        if (id) {
            initializeOperationDetails();
        }
    }, []);

    const initializeOperationDetails = () => {

        api.getOperationsDetails(id).then((res) => {
            if (res?.status) {
                const data = {
                    id: res?.data?.id,
                    referenceNo: res?.data?.reference_number,
        			purchaseInvoiceId: res?.data?.purchase_invoice_id,
                    action: 'view',
                    type: 'inbound',
                    isCompleted: res?.data?.is_completed,
                    products: res?.data?.items,
					logs: res?.data?.logs,
					status: res?.data?.status,
					invoice: res?.data?.invoice,
					sales_order: res?.data?.sales_order,
					purchaseOrderNumber: res?.data?.purchase_order_number,
					supplier: res?.data?.supplier
                }
                setOperationDetails(data);
            }
        });
    }




    const handleReloadData = () => {
        initializeOperationDetails();
    }
    const handleReloadDataFromPicklist = () => {
        initializeOperationDetails();
        setShowMoveToPicklistModal(false)
    }
    const triggerCheckboxAction = () => {
        setOpenGradingModal(true)
    }
    const closeGradingModal = () => {
        setOpenGradingModal(false)
    }

    const handleClose = () => {
        setShowMoveToPicklistModal(false)
    }

    const uncheckAllItems = () => {
        let items = operationDetails?.products.map((item) => {
            item.isChecked = false;
            return item;
        });
        setOperationDetails({
            ...operationDetails,
            products: items
        })
        toggleCheckboxAction(false)
    }


    const checkboxActionRef = useRef(null);

    useEffect(() => {
        if (!toggleCheckboxActionStatus) return;

        const handleClickOutside = (event) => {
            if (
                checkboxActionRef.current &&
                !checkboxActionRef.current.contains(event.target)
            ) {
                uncheckAllItems();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [toggleCheckboxActionStatus]);


    const getChildSelectedItems = (items) => {
        setCountSelectedItems(items?.length);
    }

    const isMobile = useIsMobile();

	return (
		<>
			<div className="row m-0 w-100" style={{ marginTop: '20px' }}>
				<div className={`col-12 col-md-12 ${isMobile ? 'p-0' : ''}`}>
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<div
								style={{
									position: 'relative',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 8,
									minHeight: 38 // ensures enough height for the button
								}}
							>
								{' '}
								<button
									type="button"
									aria-label="Back"
									onClick={() => history(-1)}
									className="circle-back-btn"
									style={{
										position: 'absolute',
										left: 20,
										top: '50%',
										transform: 'translateY(-50%)'
									}}
								>
									{/* Replace with your fi arrow icon, example below */}
									<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
										<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</button>
								<h5
									style={{
										textAlign: 'center',
										flex: 1,
										margin: 0,
										display: 'flex',
										gap: 10,
										justifyContent: 'center',
										alignItems: 'center'
									}}
								>
									{' '}
									{operationDetails?.referenceNo ? operationDetails?.referenceNo : 'New Inbound'}{' '}
								</h5>
							</div>
							<div style={{ display: 'flex', justifyContent: 'center', width: 'center' }}>
								{edit && (
									operationDetails?.isCompleted === 0 ? (
										<button
											type="button"
											onClick={() => {
												setShowMoveToPicklistModal(true);
											}}
											className="btn btn-primary btn-outlined-main"
										>
											<ShareIcon width={'15px'} height={'15px'} />
											Move to Picklist
										</button>
									) : (
										<button type="button" disabled={true} className="btn btn-primary btn-outlined-main disabled">
											<ShareIcon width={'15px'} height={'15px'} />
											Moved to Picklist
										</button>
									)
								)}
							</div>
						</div>
					</div>
					{isMobile && (
						<div>
							<BreadcrumbsMobile
								current={`inbound`}
								activateTabsUsingId={operationDetails?.id}
								referenceNumber={operationDetails?.referenceNo}
							/>
						</div>
					)}
					<div className="section-head hide-on-mobile" style={{ paddingLeft: '0' }}>
						<h2>
							<div className="actions" style={{ display: 'flex', width: '100%' }}>
								<Breadcrumbs
									current={`qualitycontrol`}
									activateTabsUsingId={operationDetails?.id}
									referenceNumber={operationDetails?.referenceNo}
									isCompleted={operationDetails?.isCompleted ? true : false}
									isDisableForm={ (edit && operationDetails?.isCompleted === 1 && !operationDetails?.purchaseInvoiceId) ? true : false }
								/>
							</div>
						</h2>
						<div className="actions">
							{edit && (
								operationDetails?.isCompleted === 0 ? (
									<button
										type="button"
										onClick={() => {
											setShowMoveToPicklistModal(true);
										}}
										className="btn btn-primary btn-outlined-main"
									>
										<ShareIcon width={'15px'} height={'15px'} />
										Move to Picklist
									</button>
								) : (
									<button type="button" disabled={true} className="btn btn-primary btn-outlined-main disabled">
										<ShareIcon width={'15px'} height={'15px'} />
										Moved to Picklist
									</button>
								)
							)}
						</div>
					</div>
					<div className={`row m-0 mobile-scroll-container ${isMobile ? 'mobile-scroll-container-xsmaller ' : ''}`}>
						<div className="col-lg-8 p-0 form-group" style={{ marginTop: '5px' }}>
							<div className={`${isMobile ? '' : 'card shadow-sm bg-white table-card p-3'}`} style={{ marginTop: '0' }}>
								<div className={`${isMobile ? '' : 'bg-white pt-0'}`} style={{ marginTop: isMobile ? '' : '-15px' }}>
									<div className={`row ${isMobile ? 'mb-3 mx-0 p-3 p-xl-4 w-100 new-card' : ''}`}>
										<div className={`${isMobile ? '' : 'col-12'}`}>
											{!isMobile ? (
												<QualityControlList
													operationDetails={operationDetails}
													handleReloadData={handleReloadData}
													handleShowCheckboxAction={toggleCheckboxAction}
													handleOpenGradingModal={openGradingModal}
													handleCloseGradingModal={closeGradingModal}
													handleGetSelectedItems={getChildSelectedItems}
												/>
											) : (
												<QualityControlListMobile
													operationDetails={operationDetails}
													handleReloadData={handleReloadData}
													handleShowCheckboxAction={toggleCheckboxAction}
													handleOpenGradingModal={openGradingModal}
													handleCloseGradingModal={closeGradingModal}
													handleGetSelectedItems={getChildSelectedItems}
												/>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-4">
							<div className="row">
								<div className={`col-12 form-group ${isMobile ? 'm-0 p-0' : ''}`}>
									<Summary operationDetails={operationDetails} />
									<Logs logs={operationDetails?.logs} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{toggleCheckboxActionStatus && !isMobile && (
				<>
					<div className="custom-footer-popup"></div>
					<div className={`row ${isMobile ? 'm-0 p-0' : ''}`}>
						<div className="col-12 checkbox-action-container">
							<div className="checkbox-action" style={{ width: '98%', position: 'absolute' }} ref={checkboxActionRef}>
								<div>Specify the grade of the output items</div>
								<PermissionAllowed permissions={['Operations Item Grading']}>
									<button
										className="btn btn-primary btn-outlined-main white-var btn-icon-only btn-icon-square"
										onClick={() => {
											triggerCheckboxAction();
										}}
									>
										<IdentifyIcon width={'16px'} height={'16px'} /> Set Grade
									</button>
								</PermissionAllowed>
								<div className="absolute justify-content-center align-items-center d-flex" style={{ width: '100%', position: 'absolute' }}>
									Selected Items: {countSelectedItems}
								</div>
								<div style={{ position: 'absolute', right: '5px', top: '0px' }} className="cursor-pointer">
									<button
										className="btn modal-close-icon"
										onClick={() => {
											uncheckAllItems();
										}}
									>
										<CloseIcon height={'16px'} width={'16px'} />
									</button>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
			{toggleCheckboxActionStatus && isMobile && (
				<div
					className="d-flex"
					style={{
						width: '100vw',
						height: '100dvh',
						position: 'fixed',
						left: 0,
						top: 0,
						zIndex: 20,
						background: 'rgba(0,0,0,0.07)',
						justifyContent: 'center',
						alignItems: 'end',
						paddingBottom: '90px',
						backdropFilter: 'blur(8px)', // <-- add this line
						WebkitBackdropFilter: 'blur(8px)' // <-- for Safari support
					}}
				>
					<div
						className="popup product-popup-mobile d-md-none"
						style={{
							position: 'relative',
							transform: 'none',
							top: 0,
							left: 0,
							maxWidth: '90%',
							background: '#fff',
							borderRadius: 12,
							boxShadow: 'rgb(0 0 0 / 37%) 0px 0px 20px',
							width: '100%',
							padding: '24px 16px 0 16px',
							display: 'flex',
							flexDirection: 'column'
						}}
					>
						<div style={{ display: 'flex', flexDirection: 'column' }} ref={checkboxActionRef}>
							<div>Specify the grade of the output items</div>
							<div>Selected Items: {countSelectedItems}</div>
							<div
								className="btnarea"
								style={{
									position: 'sticky',
									bottom: 0,
									left: 0,
									width: '100%',
									background: '#fff',
									padding: '16px 0 12px 0',
									zIndex: 30,
									display: 'flex',
									gap: 10,
									justifyContent: 'center',
									marginTop: 'auto'
								}}
							>
								<PermissionAllowed permissions={['Operations Item Grading']}>
									<button
										className="btn btn-primary btn-outlined-main white-var btn-icon-only btn-icon-square"
										onClick={() => {
                                            triggerCheckboxAction();
                                            setToggleCheckboxActionStatus(false);
										}}
									>
										<IdentifyIcon width={'16px'} height={'16px'} /> Set Grade
									</button>
								</PermissionAllowed>

								<button
									className="btn new-btn-error"
									onClick={() => {
										uncheckAllItems();
									}}
								>
									<FaTimes /> Close
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
			{showMoveToPicklistModal && (
				<MoveToPicklistModal
					openPopup={showMoveToPicklistModal}
					details={operationDetails}
					handleClose={handleClose}
					handleReloadDataFromPicklist={handleReloadDataFromPicklist}
				/>
			)}
		</>
	);
}

export default OperationQualityControlView;
